import { put, takeEvery } from 'redux-saga/effects';

import { POST_ACTIVITY_PENDING } from './druid/actions/postActivity';
import setSuggestedActions from './druid/actions/setSuggestedActions';
import whileConnected from '/druid/effects/whileConnected';

function* clearSuggestedActions() {
  yield put(setSuggestedActions());
}

function* clearSuggestedActionsOnPostActivity() {
  yield takeEvery(
    ({ payload, type }) => type === POST_ACTIVITY_PENDING && payload.activity.type === 'message',
    clearSuggestedActions
  );
}

export default function* clearSuggestedActionsOnPostActivitySaga() {
  yield whileConnected(clearSuggestedActionsOnPostActivity);
}
